import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import {API_URL} from 'src/app/pathConfig';
if (environment.production) {
    Sentry.init({
        dsn: 'https://92dcd15bc40ca4e4c4464acb31ab29aa@o4506470979993600.ingest.us.sentry.io/4506856722071552',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                maskAllInputs: true,
                blockAllMedia: true,
            }),
        ],
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [new RegExp('^' + API_URL + '/')],
        // Session Replay: only error sessions are recorded, always fully masked (manager screens contain PII/financial data)
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    });
    enableProdMode();
}

if (environment.production) {
    const googleMapsApiUrl = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=geometry,places&callback=Function.prototype`;
    const script = document.createElement('script');
    script.src = googleMapsApiUrl;
    script.defer = true;
    script.async = true;
    document.head.appendChild(script);
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((success) => console.log('Bootstrap success'))
    .catch((err) => console.error(err));
